let logoObserver;
let singleObserver;

var metaThemeColor = document.querySelector("meta[name=theme-color]");

export function navInitHome(){
    // burger menu on mobile
    const burger = document.getElementById('nav-burger');
    const nav = document.querySelector("#nav");
    let navCtn;
    if (nav) {
        navCtn = nav.querySelector('.nav-ctn');
    }
    const navPanel = document.getElementById('nav-panel');
    const navClose = document.getElementById('nav-close-button');

    if(burger) {
        burger.addEventListener('click', (event) => {
            navPanel.classList.add('nav-panel--active');
            nav.classList.add('nav--active');
        })
        navClose.addEventListener('click', (event) => {
            navPanel.classList.remove('nav-panel--active');
            nav.classList.remove('nav--active');
        })
    }

    // Smooth scroll on nav buttons click
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            navPanel.classList.remove('nav-panel--active');
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
        
    logoObserver = createLogoObserver();

    window.addEventListener("resize", () => {
        logoObserver.disconnect();
        logoObserver = createLogoObserver();
    })

    // Hide on scroll 
    let blockScrollUpdate = false;
    let isNavbarHidden = false;
    let lastScrollY = 0;
    const tresholdHideNavbar = 200;

    const handleScrollHide = () => {
        let currentScrollY = window.scrollY;

        if (!blockScrollUpdate) {
            window.requestAnimationFrame(() => {
                if (currentScrollY < lastScrollY) {
                    isNavbarHidden = false;
                } else {
                    if (tresholdHideNavbar) {
                        isNavbarHidden = currentScrollY > lastScrollY && currentScrollY > document.documentElement.clientHeight * 3 + 200;
                    } else {
                        isNavbarHidden = currentScrollY > lastScrollY && currentScrollY > 400;
                    }
                }
                lastScrollY = currentScrollY;
                blockScrollUpdate = false;
            })
            blockScrollUpdate = true;

            if (isNavbarHidden) {
                if(navCtn) {
                    navCtn.classList.add("hide-navbar");
                }
            } else {
                if(navCtn) {
                    navCtn.classList.remove("hide-navbar");
                }
            }
        }
    }

    window.addEventListener('scroll', handleScrollHide);
    if(navCtn) {
        navCtn.classList.remove("navbar-prevent-loading-transition");
    }
}

export function navInitSingle() {
    singleObserver = createSingleObserver();
    window.addEventListener("resize", () => {
        // navDisable();
        if (singleObserver) {
            singleObserver.disconnect();
            singleObserver = createSingleObserver();
        }
    })

    // var postSection = document.querySelector('.section-post');
    // if (postSection) {
    //     if (postSection.classList.contains('albums-de-l-annee-post') || postSection.classList.contains('lives-post')) {
    //         metaThemeColor.setAttribute("content", '#2EAF78');
    //     } else if (postSection.classList.contains('focus-post')){
    //         metaThemeColor.setAttribute("content", '#4663FF');
    //     } else {
    //         metaThemeColor.setAttribute("content", '#FF6C36');
    //     }
    // }

}

function handleHomeIntersection(entries) {
    // const logo = document.getElementById('abcdr_logo');
    // if (logo){
    //     entries.map((entry) => {
    //         if (entry.intersectionRatio <= 0){
    //             // console.log(entry.target.classList);
    //             return;
    //         }
    //         if (entry.isIntersecting) {
    //             if (entry.target.classList.contains('section-top-albums') || entry.target.classList.contains('section-lives') ){
    //                 logo.classList.add('abcdr_logo--green');
    //                 metaThemeColor.setAttribute("content", '#2EAF78');
    //             }else if (entry.target.classList.contains('section-focus') ){
    //                 logo.classList.add('abcdr_logo--blue');
    //                 metaThemeColor.setAttribute("content", '#4663FF');
    //             } else {
    //                 logo.classList.remove('abcdr_logo--green','abcdr_logo--blue','abcdr_logo--lightyellow','abcdr_logo--otheryellow');
    //                 metaThemeColor.setAttribute("content", '#FF6C36');
    //             }
    //         } 
    //     });
    // }
}

function handleSingleIntersection(entries) {
    const navCloseButton = document.getElementById('single-post-close-button');
    if (navCloseButton) {
        entries.map((entry) => {
            if (entry.isIntersecting ) {
                navCloseButton.classList.add('close-button--black');
            } else {
                navCloseButton.classList.remove('close-button--black');
            }
        });
    }
}


function createLogoObserver(){
    // Changement de couleur du logo
    const sections = document.querySelectorAll('.section');
    const nav = document.getElementById('nav');
    
    if(nav) {
        const navHeight = nav.clientHeight;
        let clientHeight = document.documentElement.clientHeight;

        let options = {
            root: null,
            rootMargin: `0px 0px ${(- clientHeight) + (navHeight)}px 0px`, // on déclare que le point de repère part du haut de la fenêtre, + la hauteur de la nav / 2, donc le milieu vertical
            threshold: 0 
        };

        let observer = new IntersectionObserver(handleHomeIntersection, options);
        sections.forEach((m) => observer.observe(m));
        return observer;
    }
}

function createSingleObserver(){
    // Changement de couleur de la croix (close-button) on single.php
    const postInfos = document.getElementById('single-post-info');
    
    if(postInfos) {
        const navCloseButton = document.getElementById('single-post-close-button');
        const navHeight = navCloseButton.clientHeight;
        let clientHeight = document.documentElement.clientHeight;
        let options = {
            root: null,
            rootMargin: `0px 0px ${(-1 *clientHeight) + (navHeight)}px 0px`, // on déclare que le point de repère part du haut de la fenêtre, + la hauteur de la nav / 2, donc le milieu vertical
            threshold: 0 
        };
        let observer = new IntersectionObserver(handleSingleIntersection, options);
        observer.observe(postInfos);
        return observer;
    }
}

export function navDisable(){
    // console.log('disabling nav');
    if (logoObserver) {
        logoObserver.disconnect();
    }
    if (singleObserver) {
        singleObserver.disconnect();
    }
    logoObserver = undefined;
    singleObserver = undefined;
}